namespace SP {
    export interface DeliveryMethod {
        id: string;
        methodKeys: string;
        name: string;
        shortName: string;
        isBusiness: boolean;
        isDropPoint: boolean;
        useColliBooking: boolean;
        isReturn: boolean;
        forceDeliveryNote: boolean;
        forceScanPackageCollection: boolean;
        warehouseNotificationPacker: string;
        addons: ShippingMethodAddon[];
        parameters: ShippingMethodParameter[];
        parcelTypes: ShippingMethodParcelType[];
        defaultParcelType: string;
        prices: { [country: string]: DeliveryPrice[] };
        orderSources: string[];
    }
}